// extracted by mini-css-extract-plugin
module.exports = {"scrollFix":"videoSection-module--scroll-fix--3zu--","title":"videoSection-module--title--2aoTy"};